import React, { useState, useEffect } from 'react';
import './App.css';



import { fetchBibleChapter } from './services/bibleApi';
import { fetchAvailableTranslations, fetchIqbiblePassage, searchIqbibleKeyword } from './services/iqbibleApi';
import { fetchAvailableEnglishApiBibleTranslations, fetchApiBiblePassage } from './services/apiBibleApi';
import { getBibleReferenceSuggestions } from './utils/bibleReferenceSuggestions';


import BibleResources from './components/BibleResources';
import BibleStore from './components/BibleStore';
import HebrewGreekAnalysis from './components/HebrewGreekAnalysis';
import UserContent from './components/UserContent';

// Place constants outside the App function
export const BIBLE_BOOKS = [
  { name: 'Genesis', chapters: 50, id: 'GEN' },
  { name: 'Exodus', chapters: 40, id: 'EXO' },
  { name: 'Leviticus', chapters: 27, id: 'LEV' },
  { name: 'Numbers', chapters: 36, id: 'NUM' },
  { name: 'Deuteronomy', chapters: 34, id: 'DEU' },
  { name: 'Joshua', chapters: 24, id: 'JOS' },
  { name: 'Judges', chapters: 21, id: 'JDG' },
  { name: 'Ruth', chapters: 4, id: 'RUT' },
  { name: '1 Samuel', chapters: 31, id: '1SA' },
  { name: '2 Samuel', chapters: 24, id: '2SA' },
  { name: '1 Kings', chapters: 22, id: '1KI' },
  { name: '2 Kings', chapters: 25, id: '2KI' },
  { name: '1 Chronicles', chapters: 29, id: '1CH' },
  { name: '2 Chronicles', chapters: 36, id: '2CH' },
  { name: 'Ezra', chapters: 10, id: 'EZR' },
  { name: 'Nehemiah', chapters: 13, id: 'NEH' },
  { name: 'Esther', chapters: 10, id: 'EST' },
  { name: 'Job', chapters: 42, id: 'JOB' },
  { name: 'Psalms', chapters: 150, id: 'PSA' },
  { name: 'Proverbs', chapters: 31, id: 'PRO' },
  { name: 'Ecclesiastes', chapters: 12, id: 'ECC' },
  { name: 'Song of Solomon', chapters: 8, id: 'SNG' },
  { name: 'Isaiah', chapters: 66, id: 'ISA' },
  { name: 'Jeremiah', chapters: 52, id: 'JER' },
  { name: 'Lamentations', chapters: 5, id: 'LAM' },
  { name: 'Ezekiel', chapters: 48, id: 'EZK' },
  { name: 'Daniel', chapters: 12, id: 'DAN' },
  { name: 'Hosea', chapters: 14, id: 'HOS' },
  { name: 'Joel', chapters: 3, id: 'JOL' },
  { name: 'Amos', chapters: 9, id: 'AMO' },
  { name: 'Obadiah', chapters: 1, id: 'OBA' },
  { name: 'Jonah', chapters: 4, id: 'JON' },
  { name: 'Micah', chapters: 7, id: 'MIC' },
  { name: 'Nahum', chapters: 3, id: 'NAM' },
  { name: 'Habakkuk', chapters: 3, id: 'HAB' },
  { name: 'Zephaniah', chapters: 3, id: 'ZEP' },
  { name: 'Haggai', chapters: 2, id: 'HAG' },
  { name: 'Zechariah', chapters: 14, id: 'ZEC' },
  { name: 'Malachi', chapters: 4, id: 'MAL' },
  // New Testament
  { name: 'Matthew', chapters: 28, id: 'MAT' },
  { name: 'Mark', chapters: 16, id: 'MRK' },
  { name: 'Luke', chapters: 24, id: 'LUK' },
  { name: 'John', chapters: 21, id: 'JHN' },
  { name: 'Acts', chapters: 28, id: 'ACT' },
  { name: 'Romans', chapters: 16, id: 'ROM' },
  { name: '1 Corinthians', chapters: 16, id: '1CO' },
  { name: '2 Corinthians', chapters: 13, id: '2CO' },
  { name: 'Galatians', chapters: 6, id: 'GAL' },
  { name: 'Ephesians', chapters: 6, id: 'EPH' },
  { name: 'Philippians', chapters: 4, id: 'PHP' },
  { name: 'Colossians', chapters: 4, id: 'COL' },
  { name: '1 Thessalonians', chapters: 5, id: '1TH' },
  { name: '2 Thessalonians', chapters: 3, id: '2TH' },
  { name: '1 Timothy', chapters: 6, id: '1TI' },
  { name: '2 Timothy', chapters: 4, id: '2TI' },
  { name: 'Titus', chapters: 3, id: 'TIT' },
  { name: 'Philemon', chapters: 1, id: 'PHM' },
  { name: 'Hebrews', chapters: 13, id: 'HEB' },
  { name: 'James', chapters: 5, id: 'JAS' },
  { name: '1 Peter', chapters: 5, id: '1PE' },
  { name: '2 Peter', chapters: 3, id: '2PE' },
  { name: '1 John', chapters: 5, id: '1JN' },
  { name: '2 John', chapters: 1, id: '2JN' },
  { name: '3 John', chapters: 1, id: '3JN' },
  { name: 'Jude', chapters: 1, id: 'JUD' },
  { name: 'Revelation', chapters: 22, id: 'REV' }
];

const TRANSLATION_LABELS = {
  BSB: 'Berean Study Bible (BSB)',
  KJV: 'King James Version (KJV)',
  WEB: 'World English Bible (WEB)',
  ASV: 'American Standard Version (ASV)',
  NIV: 'New International Version (NIV)',
  ESV: 'English Standard Version (ESV)',
  NLT: 'New Living Translation (NLT)',
  NASB: 'New American Standard Bible (NASB)',
  CSB: 'Christian Standard Bible (CSB)',
  NKJV: 'New King James Version (NKJV)',
  MSG: 'The Message (MSG)',
};





function App() {
  // Track if Next has been clicked in Reading Mode
  const [showPrev, setShowPrev] = useState(false);
  // Print scripture handler
  function handlePrintScripture() {
    const content = document.querySelector('.bible-content');
    if (!content) {
      window.print();
      return;
    }
    const printWindow = window.open('', '', 'width=800,height=600');
    if (!printWindow) return;
    let styleSheets = '';
    Array.from(document.styleSheets).forEach(function(sheet) {
      try {
        if (sheet.href) {
          styleSheets += '<link rel="stylesheet" href="' + sheet.href + '">\n';
        }
      } catch (e) {}
    });
    printWindow.document.write('<html><head><title>Print Scripture</title>' +
      styleSheets +
      '<style>body { font-family: inherit; margin: 40px; } .chapter-header { margin-bottom: 16px; } .verses { font-size: 1.1em; } .verse { margin-bottom: 8px; } .verse-number { font-weight: bold; margin-right: 6px; } .verse-text { }</style>' +
      '</head><body><div class="bible-content">' + content.innerHTML + '</div></body></html>'
    );
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  }
  // Toggle Reading Mode
  const toggleReadingMode = () => {
    setReadingMode((prev) => {
      if (prev) setShowPrev(false); // Reset when exiting Reading Mode
      return !prev;
    });
  };
  const scrollTargetRef = React.useRef(null);
  // Reading Mode state
  const [readingMode, setReadingMode] = useState(false);
  // --- Move all state and dependent variables to the top ---
  const [searchResults, setSearchResults] = useState(null);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [pendingScrollVerse, setPendingScrollVerse] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [currentBook, setCurrentBook] = useState('Genesis');
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
  });
  const [currentChapter, setCurrentChapter] = useState(1);
  const [currentTranslation, setCurrentTranslation] = useState('BSB');
  const [fontSize, setFontSize] = useState('Medium');
  const [availableTranslations, setAvailableTranslations] = useState([]);
  // Compare feature state
  const [showCompare, setShowCompare] = useState(false);
  const [compareTranslation, setCompareTranslation] = useState('AMP');
  const [compareVerses, setCompareVerses] = useState([]);

  // Fetch available translations on mount
  useEffect(() => {
    async function loadTranslations() {
      try {
        // Fetch IQBible translations
        const iqbibleTranslations = await fetchAvailableTranslations();
        const iqbibleWithSource = iqbibleTranslations.map(t => ({ ...t, source: 'IQBible' }));

        // Fetch HelloAO English translations
        const res = await fetch('https://bible.helloao.org/api/available_translations.json');
        const data = await res.json();
        const helloaoEnglish = (data.translations || [])
          .filter(t => t.language === 'eng')
          .map(t => ({
            code: t.id,
            label: t.englishName || t.name,
            source: 'HelloAO',
          }));

        // Fetch available API.Bible English translations
        const apiBibleAvailable = await fetchAvailableEnglishApiBibleTranslations();
        const apiBibleWithSource = apiBibleAvailable.map(t => ({ ...t, source: 'API.Bible' }));

        // Combine and set
        const allTranslations = [
          ...apiBibleWithSource,
          ...iqbibleWithSource,
          ...helloaoEnglish
        ];
        setAvailableTranslations(allTranslations);
        // Prefer NKJV as default if available, else first available
        const nkjv = allTranslations.find(t => t.code.toUpperCase() === 'NKJV');
        if (nkjv) {
          setCurrentTranslation(nkjv.code);
        } else if (allTranslations.length > 0) {
          setCurrentTranslation(allTranslations[0].code);
        }
      } catch (err) {
        setAvailableTranslations([]);
      }
    }
    loadTranslations();
  }, []);
  const [activeTab, setActiveTab] = useState('resources');
  const [selectedVerse, setSelectedVerse] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showStore, setShowStore] = useState(false);
  const [verses, setVerses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isReading, setIsReading] = useState(false);
  const [selectedVerseData, setSelectedVerseData] = useState(null);
  // Helper for current book data (must come after currentBook is defined)
  const currentBookData = BIBLE_BOOKS.find(book => book.name === currentBook);

  // --- Effects and logic follow ---
  // Fetch verses when book, chapter, or translation changes
  const [noVersesMessage, setNoVersesMessage] = useState("");
  useEffect(() => {
    async function loadVerses() {
      setLoading(true);
      setNoVersesMessage("");
      try {
        // Find the selected translation object
        const selected = availableTranslations.find(t => t.code === currentTranslation);
        let versesData = [];
        if (selected) {
          if (selected.source === 'HelloAO') {
            versesData = await fetchBibleChapter(currentBook, currentChapter, selected.code);
          } else if (selected.source === 'API.Bible') {
            // Find the correct bibleId for API.Bible
            const bookObj = BIBLE_BOOKS.find(b => b.name === currentBook);
            if (bookObj) {
              versesData = await fetchApiBiblePassage({
                bibleId: selected.id,
                bookId: bookObj.id,
                chapter: currentChapter
              });
            }
          } else {
            const reference = `${currentBook} ${currentChapter}`;
            versesData = await fetchIqbiblePassage(reference, currentTranslation.toLowerCase());
          }
        }
        if (!versesData || versesData.length === 0) {
          // Try to auto-switch to the first available translation with verses
          let found = false;
          for (const t of availableTranslations) {
            if (t.code === currentTranslation) continue;
            let testVerses = [];
            try {
              if (t.source === 'HelloAO') {
                testVerses = await fetchBibleChapter(currentBook, currentChapter, t.code);
              } else if (t.source === 'API.Bible') {
                const bookObj = BIBLE_BOOKS.find(b => b.name === currentBook);
                if (bookObj) {
                  testVerses = await fetchApiBiblePassage({
                    bibleId: t.id,
                    bookId: bookObj.id,
                    chapter: currentChapter
                  });
                }
              } else {
                const ref = `${currentBook} ${currentChapter}`;
                testVerses = await fetchIqbiblePassage(ref, t.code.toLowerCase());
              }
            } catch {}
            if (testVerses && testVerses.length > 0) {
              setCurrentTranslation(t.code);
              setVerses(testVerses);
              setNoVersesMessage(`No verses found for this translation. Switched to: ${t.label} (${t.code})`);
              found = true;
              break;
            }
          }
          if (!found) {
            setVerses([]);
            setNoVersesMessage("No verses found for any available translation for this book/chapter.");
          }
        } else {
          setVerses(versesData);
        }
      } catch (err) {
        setVerses([]);
        setNoVersesMessage("No verses found for this translation, book, or chapter. Please try a different translation or check your network connection.");
      } finally {
        setLoading(false);
      }
    }
    loadVerses();
  }, [currentBook, currentChapter, currentTranslation, availableTranslations]);

  // Fetch verses for compare translation
  useEffect(() => {
    async function loadCompareVerses() {
      if (!showCompare) {
        setCompareVerses([]);
        return;
      }
      const selected = availableTranslations.find(t => t.code === compareTranslation);
      let versesData = [];
      if (selected) {
        if (selected.source === 'HelloAO') {
          versesData = await fetchBibleChapter(currentBook, currentChapter, selected.code);
        } else if (selected.source === 'API.Bible') {
          const bookObj = BIBLE_BOOKS.find(b => b.name === currentBook);
          if (bookObj) {
            versesData = await fetchApiBiblePassage({
              bibleId: selected.id,
              bookId: bookObj.id,
              chapter: currentChapter
            });
          }
        } else {
          const reference = `${currentBook} ${currentChapter}`;
          versesData = await fetchIqbiblePassage(reference, compareTranslation.toLowerCase());
        }
      }
      setCompareVerses(versesData);
    }
    loadCompareVerses();
  }, [showCompare, compareTranslation, currentBook, currentChapter, availableTranslations]);

  useEffect(() => {
    if (theme === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Scroll to and highlight verse after search
  useEffect(() => {

    if (pendingScrollVerse && verses && verses.length > 0) {
      // Find the verse object
      const found = verses.find(v => v.verse === pendingScrollVerse);
      if (found) {
        setSelectedVerse(found);
        // Scroll to the verse element
        setTimeout(() => {
          const el = document.getElementById(`verse-${pendingScrollVerse}`);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
      }
      setPendingScrollVerse(null);
    }
  }, [pendingScrollVerse, verses]);

  // Automatically switch to Resources tab when a verse is selected
  useEffect(() => {
    if (!selectedVerse && activeTab === 'resources') {
      // Stay on resources tab, show placeholder (handled in render)
      return;
    }
    if (selectedVerse) {
      setActiveTab('resources');
    }
  }, [selectedVerse]);

  // Scroll to and highlight verse after search (anchor navigation)
  useEffect(() => {
    if (scrollTargetRef.current && verses && verses.length > 0) {
      const verseNum = scrollTargetRef.current;
      const found = verses.find(v => v.verse === verseNum);
      if (found) {
        setSelectedVerse(found);
        setTimeout(() => {
          const el = document.getElementById(`verse-${verseNum}`);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
      }
      scrollTargetRef.current = null;
    }
    // legacy: also support pendingScrollVerse for other flows
    if (pendingScrollVerse && verses && verses.length > 0) {
      const found = verses.find(v => v.verse === pendingScrollVerse);
      if (found) {
        setSelectedVerse(found);
        setTimeout(() => {
          const el = document.getElementById(`verse-${pendingScrollVerse}`);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
      }
      setPendingScrollVerse(null);
    }
  }, [pendingScrollVerse, verses]);

  const handleBookChange = (bookName) => {
    setCurrentBook(bookName);
    setCurrentChapter(1);
    setSelectedVerse(null);
  };

  const handleChapterChange = (chapter) => {
    setCurrentChapter(chapter);
    setSelectedVerse(null);
  };

  const handleDropdownChange = (e) => {
    const [bookName, chapterNum] = e.target.value.split(' ');
    const chapter = parseInt(chapterNum);
    setCurrentBook(bookName);
    setCurrentChapter(chapter);
    setSelectedVerse(null);
  };

  const toggleAudio = () => {
    if (isReading) {
      window.speechSynthesis.cancel();
      setIsReading(false);
    } else {
      const text = verses.map(v => v.text).join(' ');
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.onend = () => setIsReading(false);
      window.speechSynthesis.speak(utterance);
      setIsReading(true);
    }
  };

  // Add this function above the return statement, after all useState/useEffect hooks
  function handleVerseClick(verse) {
    setSelectedVerse(verse);
  }

  function handleSearch(forcedValue) {
    const input = (forcedValue !== undefined ? forcedValue : searchValue).trim();
    // Book Chapter:Verse (e.g., John 3:16)
    let match = input.match(/^(.*?)\s*(\d+):(\d+)$/);
    if (!match) {
      // Also support Book Chapter Verse (e.g., John 3 16)
      match = input.match(/^(.*?)\s+(\d+)\s+(\d+)$/);
    }
    if (match) {
      const bookName = match[1].trim();
      const chapter = parseInt(match[2], 10);
      const verseNum = parseInt(match[3], 10);
      const book = BIBLE_BOOKS.find(b => b.name.toLowerCase() === bookName.toLowerCase());
      if (book) {
        scrollTargetRef.current = verseNum;
        setCurrentBook(book.name);
        setCurrentChapter(chapter);
      }
      return;
    }
    // Book Chapter only (e.g., John 2)
    const matchChapterOnly = input.match(/^(.*?)\s*(\d+)$/);
    if (matchChapterOnly) {
      const bookName = matchChapterOnly[1].trim();
      const chapter = parseInt(matchChapterOnly[2], 10);
      const book = BIBLE_BOOKS.find(b => b.name.toLowerCase() === bookName.toLowerCase());
      if (book && chapter > 0 && chapter <= book.chapters) {
        setSearchResults([]);
        setShowSearchResults(true);
        setNoVersesMessage('Please include a verse number, e.g., "John 2:1"');
        return;
      }
    }
    // Use IQBible API for keyword search
    setLoading(true);
    searchIqbibleKeyword(input, currentTranslation.toLowerCase())
      .then(results => {
        setSearchResults(results || []);
        setShowSearchResults(true);
      })
      .catch(() => {
        setSearchResults([]);
        setShowSearchResults(true);
      })
      .finally(() => setLoading(false));
  }

  // Keyword search results modal
  const renderSearchResultsModal = () => {
    if (!showSearchResults) return null;
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.4)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 8,
          maxWidth: 600,
          width: '90vw',
          maxHeight: '80vh',
          overflowY: 'auto',
          boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
          padding: 24,
        }}>
          <h2 className="search-results-header">Search Results</h2>
          {noVersesMessage ? (
            <div style={{color: '#b91c1c', margin: '16px 0'}}>{noVersesMessage}</div>
          ) : searchResults && searchResults.length > 0 ? (
            <ul style={{padding: 0, margin: 0, listStyle: 'none'}}>
              {searchResults.map((r, i) => (
                <li key={i} style={{marginBottom: 16, borderBottom: '1px solid #eee', paddingBottom: 8}}>
                  <strong>{r.reference}</strong>: <span>{r.text}</span>
                </li>
              ))}
            </ul>
          ) : (
            <div style={{color: '#b91c1c', margin: '16px 0'}}>No results found for your keyword search.</div>
          )}
          <button style={{marginTop: 16}} onClick={() => setShowSearchResults(false)}>Close</button>
        </div>
      </div>
    );
  } // <-- properly close the function here


  if (showStore) {
    return <BibleStore onBack={() => setShowStore(false)} />;
  }

  return (
    <div className="app">
      {renderSearchResultsModal()}
  {/* Compare feature removed */}
      {/* Header (hide in reading mode) */}
      {!readingMode && (
        <header className="header">
          <div className="header-left">
            <img src="logo44.png" alt="Dominion Kingdom Bible" className="logo" />
          </div>
          <div className="header-center">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search verses, topics, or navigate (e.g., John 3:16)"
                className="search-input"
                value={searchValue}
                onChange={e => {
                  setSearchValue(e.target.value);
                  if (e.target.value.length > 0) {
                    setSearchSuggestions(getBibleReferenceSuggestions(e.target.value));
                    setShowSuggestions(true);
                  } else {
                    setShowSuggestions(false);
                    setSearchSuggestions([]);
                  }
                }}
              />
              {showSuggestions && searchSuggestions.length > 0 && (
                <ul className="search-suggestions-dropdown">
                  {searchSuggestions.map((s, i) => (
                    <li
                      key={s + i}
                      onMouseDown={() => {
                        setSearchValue(s);
                        setShowSuggestions(false);
                        setTimeout(() => handleSearch(s), 0);
                      }}
                    >
                      {s}
                    </li>
                  ))}
                </ul>
              )}
              <button className="search-button" onClick={() => handleSearch()} type="button">🔍</button>
            </div>
          </div>
          <div className="header-right">
            <button
              className="header-btn darkmode-btn"
              onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
              title="Toggle light/dark mode"
              aria-label="Toggle light/dark mode"
            >
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
          </div>
        </header>
      )}
      <div className="main-container">
        {/* Mobile nav-buttons above main-content */}
        <div className="nav-buttons mobile-nav-buttons mobile-only">
          <button
            className={`nav-btn back-website-btn${theme === 'dark' ? ' dark' : ''}`}
            onClick={() => window.location.href = 'http://dominionkingdombible.org/' }
            style={theme === 'dark' ? { background: '#3b82f6', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 } : { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
          >
            <span role="img" aria-label="Back">🔙</span> Back to website
          </button>
          <button 
            className={`nav-btn ${!showStore ? 'active' : ''}`}
            onClick={() => setShowStore(false)}
          >
            📖 Read the Bible
          </button>
        </div>
        {/* Sidebar */}
        {!readingMode && (
          <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
            <button 
              className={`collapse-btn custom-collapse-btn${sidebarCollapsed ? ' collapsed' : ''}`}
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            >
              {sidebarCollapsed ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5L13 10L8 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5L7 10L12 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </button>
            {!sidebarCollapsed && (
              <>
                <div className="nav-buttons">
                  <button 
                    className={`nav-btn back-website-btn${theme === 'dark' ? ' dark' : ''}`}
                    onClick={() => window.location.href = 'http://dominionkingdombible.org/' }
                    style={theme === 'dark' ? { background: '#3b82f6', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 } : { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
                  >
                    <span role="img" aria-label="Back">🔙</span> Back to website
                  </button>
                  <button 
                    className={`nav-btn ${!showStore ? 'active' : ''}`}
                    onClick={() => setShowStore(false)}
                  >
                    📖 Read the Bible
                  </button>
                </div>
                <div className="bible-books">
                  <h3>Bible Books</h3>
                  <div className="books-section">
                    <h4>OLD TESTAMENT</h4>
                    <div className="books-grid">
                      {BIBLE_BOOKS.slice(0, 39).map((book, index) => (
                        <button
                          key={book.name}
                          className={`book-btn ${currentBook === book.name ? 'active' : ''}`}
                          onClick={() => handleBookChange(book.name)}
                        >
                          {book.name}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="books-section">
                    <h4>NEW TESTAMENT</h4>
                    <div className="books-grid">
                      {BIBLE_BOOKS.slice(39).map((book, index) => (
                        <button
                          key={book.name}
                          className={`book-btn ${currentBook === book.name ? 'active' : ''}`}
                          onClick={() => handleBookChange(book.name)}
                        >
                          {book.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        {/* Main Content */}
        <div className={`main-content${readingMode ? ' reading-mode' : ''}${showCompare ? ' compare-mode' : ''}`}> 
          {/* Exit Reading Mode button at top right when in reading mode */}
          {readingMode && (
            <button
              className="exit-reading-mode-btn"
              onClick={toggleReadingMode}
              title="Exit Reading Mode"
              aria-label="Exit Reading Mode"
              style={{
                position: 'absolute',
                top: 26,
                right: 26,
                zIndex: 1000,
                background: 'rgba(255,255,255,0.8)',
                border: 'none',
                borderRadius: '50%',
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 24,
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
              }}
            >
              &#10005;
            </button>
          )}
          {/* Next/Previous buttons at the bottom in Reading Mode */}
          {readingMode && (
            <div style={{
              position: 'fixed',
              left: 0,
              bottom: 0,
              width: '100vw',
              display: 'flex',
              justifyContent: 'center',
              gap: 24,
              background: theme === 'dark' ? '#232946' : '#f4f4f4',
              padding: '18px 0 18px 0',
              zIndex: 2001,
              boxShadow: '0 -2px 12px rgba(0,0,0,0.08)'
            }}>
              {showPrev && !(currentChapter === 1 && BIBLE_BOOKS.findIndex(b => b.name === currentBook) === 0) ? (
                <button
                  className="reading-nav-btn"
                  style={{
                    fontSize: 18,
                    padding: '10px 28px',
                    borderRadius: 8,
                    border: '1px solid #3b82f6',
                    background: '#fff',
                    color: '#3b82f6',
                    fontWeight: 600,
                    cursor: 'pointer',
                    opacity: 1
                  }}
                  onClick={() => {
                    const bookIdx = BIBLE_BOOKS.findIndex(b => b.name === currentBook);
                    if (currentChapter > 1) {
                      if (currentChapter - 1 === 1 && bookIdx === 0) {
                        setCurrentChapter(currentChapter - 1);
                        setShowPrev(false);
                        window.scrollTo(0, 0);
                        return;
                      }
                      setCurrentChapter(currentChapter - 1);
                    } else if (bookIdx > 0) {
                      if (BIBLE_BOOKS[bookIdx - 1].chapters === 1 && bookIdx - 1 === 0) {
                        setCurrentBook(BIBLE_BOOKS[bookIdx - 1].name);
                        setCurrentChapter(1);
                        setShowPrev(false);
                        window.scrollTo(0, 0);
                        return;
                      }
                      setCurrentBook(BIBLE_BOOKS[bookIdx - 1].name);
                      setCurrentChapter(BIBLE_BOOKS[bookIdx - 1].chapters);
                    }
                    if (currentChapter === 1 && bookIdx === 0) setShowPrev(false);
                    window.scrollTo(0, 0);
                  }}
                >
                  &#8592; Previous
                </button>
              ) : null}
              <button
                className="reading-nav-btn"
                style={{
                  fontSize: 18,
                  padding: '10px 28px',
                  borderRadius: 8,
                  border: '1px solid #3b82f6',
                  background: '#fff',
                  color: '#3b82f6',
                  fontWeight: 600,
                  cursor: (currentChapter === currentBookData.chapters && BIBLE_BOOKS.findIndex(b => b.name === currentBook) === BIBLE_BOOKS.length - 1) ? 'not-allowed' : 'pointer',
                  opacity: (currentChapter === currentBookData.chapters && BIBLE_BOOKS.findIndex(b => b.name === currentBook) === BIBLE_BOOKS.length - 1) ? 0.5 : 1
                }}
                disabled={currentChapter === currentBookData.chapters && BIBLE_BOOKS.findIndex(b => b.name === currentBook) === BIBLE_BOOKS.length - 1}
                onClick={() => {
                  const bookIdx = BIBLE_BOOKS.findIndex(b => b.name === currentBook);
                  if (currentChapter < currentBookData.chapters) {
                    setCurrentChapter(currentChapter + 1);
                  } else if (bookIdx < BIBLE_BOOKS.length - 1) {
                    setCurrentBook(BIBLE_BOOKS[bookIdx + 1].name);
                    setCurrentChapter(1);
                  }
                  setShowPrev(true);
                  window.scrollTo(0, 0);
                }}
              >
                Next &#8594;
              </button>
            </div>
          )}
          {/* Second Exit Reading Mode button at bottom right when in reading mode */}
          {/* Toolbar */}
          {!readingMode && (
            <div className="toolbar">
              <select 
                value={currentBook && currentChapter ? `${currentBook} ${currentChapter}` : ""}
                onChange={handleDropdownChange}
                className="book-chapter-select"
              >
                <option value="" disabled hidden>Select Chapter</option>
                {BIBLE_BOOKS.map(book => 
                  Array.from({length: book.chapters}, (_, i) => i + 1).map(chapter => (
                    <option key={`${book.name} ${chapter}`} value={`${book.name} ${chapter}`}>
                      {book.name} {chapter}
                    </option>
                  ))
                )}
              </select>
              <select 
                value={currentTranslation || ""}
                onChange={(e) => {
                  setCurrentTranslation(e.target.value);
                }}
                className="translation-select"
              >
                <option value="" disabled hidden>Select Translation</option>
                {availableTranslations.length === 0 ? (
                  <option>Loading...</option>
                ) : (
                  Array.from(
                    availableTranslations
                      .filter(t => t.source === 'API.Bible')
                      .reduce((map, t) => {
                        if (!map.has(t.code)) map.set(t.code, t);
                        return map;
                      }, new Map())
                      .values()
                  )
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map(t => (
                      <option key={t.code} value={t.code}>
                        {t.label} ({t.code})
                      </option>
                    ))
                )}
              </select>
              {/* Compare translation dropdown, only show in Compare mode */}
              {showCompare && (
                <select
                  value={compareTranslation || ""}
                  onChange={e => setCompareTranslation(e.target.value)}
                  className="compare-translation-select"
                  style={{ marginLeft: 8 }}
                >
                  <option value="" disabled hidden>Compare Translation</option>
                  {availableTranslations.filter(t => t.code !== currentTranslation).map(t => (
                    <option key={t.code} value={t.code}>{t.label} ({t.code})</option>
                  ))}
                </select>
              )}
              <select 
                value={fontSize || ""}
                onChange={(e) => setFontSize(e.target.value)}
                className="font-select"
              >
                <option value="" disabled hidden>Increase Font Size</option>
                <option value="Small">Small</option>
                <option value="Medium">Medium</option>
                <option value="Large">Large</option>
              </select>
              <div className="toolbar-buttons">
                <button
                  className={`toolbar-btn compare-btn${showCompare ? ' active' : ''}`}
                  title="Compare Scriptures"
                  aria-label="Compare Scriptures"
                  onClick={() => setShowCompare(!showCompare)}
                  style={showCompare ? { background: '#3b82f6', color: '#fff' } : {}}
                >
                  🔀
                </button>
                <button
                  className="toolbar-btn reading-mode-btn"
                  onClick={toggleReadingMode}
                  title={readingMode ? 'Exit Reading Mode' : 'Enter Reading Mode'}
                  aria-label={readingMode ? 'Exit Reading Mode' : 'Enter Reading Mode'}
                >
                  {readingMode ? '🡸' : '📖'}
                </button>
                <button className="toolbar-btn print-btn" title="Print" aria-label="Print" onClick={handlePrintScripture}>🖨️</button>
                <button className="toolbar-btn audio-btn" onClick={toggleAudio} title={isReading ? 'Stop Audio' : 'Play Audio'} aria-label={isReading ? 'Stop Audio' : 'Play Audio'}>
                  {isReading ? '⏹️' : '🔊'}
                </button>
              </div>
            </div>
          )}
          {/* Chapter Selection */}
          {!readingMode && (
            <div className="chapter-selection">
              <h3>{currentBook} - Select Chapter:</h3>
              <div className="chapter-buttons">
                {Array.from({length: currentBookData?.chapters || 1}, (_, i) => i + 1).map(chapter => (
                  <button
                    key={chapter}
                    className={`chapter-button ${currentChapter === chapter ? 'active' : ''}`}
                    onClick={() => handleChapterChange(chapter)}
                  >
                    {chapter}
                  </button>
                ))}
              </div>
            </div>
          )}
          {/* Content Area */}
          <div className={`content-area${showCompare ? ' compare-mode' : ''}`}> 
            {showCompare ? (
              <>
                <div className="bible-content">
                  {/* Show message if no verses returned */}
                  {(!loading && (!verses || verses.length === 0) && noVersesMessage) && (
                    <div style={{color: '#b91c1c', background: '#fef2f2', padding: '16px', borderRadius: '8px', marginBottom: '16px', textAlign: 'center'}}>
                      {noVersesMessage}
                    </div>
                  )}
                  {/* Chapter Title */}
                  <div className="chapter-header" key={`chapter-header-${currentChapter}-${showCompare}`}> 
                    <div className="chapter-number">{currentChapter}</div>
                    <div className="chapter-info">
                      <h2>{currentBook}</h2>
                      <p className="chapter-subtitle">Chapter {currentChapter}</p>
                    </div>
                  </div>
                  {/* Two-column compare mode */}
                  <div className="compare-columns">
                    <div className={`verses font-${fontSize.toLowerCase()} compare-col`}>
                      <div className="compare-col-header">{availableTranslations.find(t => t.code === currentTranslation)?.label || currentTranslation}</div>
                      {loading ? (
                        <div className="loading">Loading chapter content...</div>
                      ) : (
                        verses.map((verse) => (
                          <div
                            key={verse.verse}
                            className={`verse${selectedVerse?.verse === verse.verse ? ' highlighted-verse' : ''}`}
                            id={`verse-${verse.verse}`}
                          >
                            <button
                              className={`verse-number ${selectedVerse?.verse === verse.verse ? 'selected' : ''}`}
                              onClick={() => handleVerseClick(verse)}
                              type="button"
                            >
                              {verse.verse}
                            </button>
                            <span className="verse-text">{verse.text}</span>
                          </div>
                        ))
                      )}
                    </div>
                    <div className={`verses font-${fontSize.toLowerCase()} compare-col`}>
                      <div className="compare-col-header">{availableTranslations.find(t => t.code === compareTranslation)?.label || compareTranslation}</div>
                      {compareVerses.length === 0 ? (
                        <div className="loading">Loading compare translation...</div>
                      ) : (
                        compareVerses.map((verse) => (
                          <div key={verse.verse} className="verse">
                            <span className="verse-number">{verse.verse}</span>
                            <span className="verse-text">{verse.text}</span>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
                {!readingMode && (
                  <div className={`right-panel compare-mode`}>
                    <div className="tab-buttons">
                      <button 
                        className={`tab-button ${activeTab === 'resources' ? 'active' : ''}`}
                        onClick={() => setActiveTab('resources')}
                      >
                        Resources
                      </button>
                      <button 
                        className={`tab-button ${activeTab === 'hebrew' ? 'active' : ''}`}
                        onClick={() => setActiveTab('hebrew')}
                      >
                        Hebrew/Greek
                      </button>
                      <button 
                        className={`tab-button ${activeTab === 'content' ? 'active' : ''}`}
                        onClick={() => setActiveTab('content')}
                      >
                        Your Content
                      </button>
                    </div>
                    <div className="tab-content">
                      {activeTab === 'resources' && (
                        selectedVerse ? (
                          <BibleResources 
                            selectedVerse={selectedVerse}
                            selectedVerseData={selectedVerseData}
                            currentBook={currentBook}
                            currentChapter={currentChapter}
                          />
                        ) : (
                          <div
                            style={{
                              padding: 32,
                              textAlign: 'center',
                              color: theme === 'dark' ? '#fff' : '#6b7280',
                              fontSize: 18
                            }}
                          >
                            <div style={{ fontSize: 48, marginBottom: 16 }}>📖</div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>
                              Select a verse to view resources
                            </div>
                            <div>
                              Click on any verse number in the passage to see commentaries, cross-references, and study materials.
                            </div>
                          </div>
                        )
                      )}
                      {activeTab === 'hebrew' && (
                        <div className="hebrew-content">
                          <h3 style={{ color: theme === 'dark' ? '#fff' : undefined }}>Hebrew/Greek Analysis</h3>
                          {selectedVerse ? (
                            <HebrewGreekAnalysis
                              bookName={currentBook}
                              chapter={currentChapter}
                              verse={selectedVerse.verse}
                            />
                          ) : (
                            <p style={{ color: theme === 'dark' ? '#fff' : undefined }}>Select a verse to see Hebrew/Greek analysis</p>
                          )}
                        </div>
                      )}
                      {activeTab === 'content' && (
                        <UserContent 
                          currentBook={currentBook}
                          currentChapter={currentChapter}
                          selectedVerse={selectedVerse}
                        />
                      )}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="bible-content">
                  {/* Show message if no verses returned */}
                  {(!loading && (!verses || verses.length === 0) && noVersesMessage) && (
                    <div style={{color: '#b91c1c', background: '#fef2f2', padding: '16px', borderRadius: '8px', marginBottom: '16px', textAlign: 'center'}}>
                      {noVersesMessage}
                    </div>
                  )}
                  {/* Chapter Title */}
                  <div className="chapter-header" key={`chapter-header-${currentChapter}-${showCompare}`}> 
                    <div className="chapter-number">{currentChapter}</div>
                    <div className="chapter-info">
                      <h2>{currentBook}</h2>
                      <p className="chapter-subtitle">Chapter {currentChapter}</p>
                    </div>
                  </div>
                  <div className={`verses font-${fontSize.toLowerCase()}`}>
                    {verses.map((verse) => (
                      <div
                        key={verse.verse}
                        className={`verse${selectedVerse?.verse === verse.verse ? ' highlighted-verse' : ''}`}
                        id={`verse-${verse.verse}`}
                      >
                        <button
                          className={`verse-number ${selectedVerse?.verse === verse.verse ? 'selected' : ''}`}
                          onClick={() => handleVerseClick(verse)}
                          type="button"
                        >
                          {verse.verse}
                        </button>
                        <span className="verse-text">{verse.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {!readingMode && (
                  <div className="right-panel">
                    <div className="tab-buttons">
                      <button 
                        className={`tab-button ${activeTab === 'resources' ? 'active' : ''}`}
                        onClick={() => setActiveTab('resources')}
                      >
                        Resources
                      </button>
                      <button 
                        className={`tab-button ${activeTab === 'hebrew' ? 'active' : ''}`}
                        onClick={() => setActiveTab('hebrew')}
                      >
                        Hebrew/Greek
                      </button>
                      <button 
                        className={`tab-button ${activeTab === 'content' ? 'active' : ''}`}
                        onClick={() => setActiveTab('content')}
                      >
                        Your Content
                      </button>
                    </div>
                    <div className="tab-content">
                      {activeTab === 'resources' && (
                        selectedVerse ? (
                          <BibleResources 
                            selectedVerse={selectedVerse}
                            selectedVerseData={selectedVerseData}
                            currentBook={currentBook}
                            currentChapter={currentChapter}
                          />
                        ) : (
                          <div
                            style={{
                              padding: 32,
                              textAlign: 'center',
                              color: theme === 'dark' ? '#fff' : '#6b7280',
                              fontSize: 18
                            }}
                          >
                            <div style={{ fontSize: 48, marginBottom: 16 }}>📖</div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>
                              Select a verse to view resources
                            </div>
                            <div>
                              Click on any verse number in the passage to see commentaries, cross-references, and study materials.
                            </div>
                          </div>
                        )
                      )}
                      {activeTab === 'hebrew' && (
                        <div className="hebrew-content">
                          <h3 style={{ color: theme === 'dark' ? '#fff' : undefined }}>Hebrew/Greek Analysis</h3>
                          {selectedVerse ? (
                            <HebrewGreekAnalysis
                              bookName={currentBook}
                              chapter={currentChapter}
                              verse={selectedVerse.verse}
                            />
                          ) : (
                            <p style={{ color: theme === 'dark' ? '#fff' : undefined }}>Select a verse to see Hebrew/Greek analysis</p>
                          )}
                        </div>
                      )}
                      {activeTab === 'content' && (
                        <UserContent 
                          currentBook={currentBook}
                          currentChapter={currentChapter}
                          selectedVerse={selectedVerse}
                        />
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
